<template>
  <HSelect
    v-model:value="selectedAssessment"
    name="channel-assessment"
    label="Nível de urgência"
    option-key="key"
    option-label="value"
    :placeholder="placeholder"
    :options="assessmentOptions"
    :disabled="disabled"
    @update:value="onInput"
  >
    <template #iconLeft>
      <CAssessmentIcon
        v-if="selectedAssessment.key"
        :assessment="selectedAssessment.key"
        icon-only
      />
    </template>
    <template #options="{ option }">
      <div class="channel-assessment__option">
        <CAssessmentIcon :assessment="option.key" icon-only />
        {{ option.value }}
      </div>
    </template>
  </HSelect>
</template>

<script>
import { CAssessmentIcon } from '@/components/channels/atoms'
import { HSelect } from '@/components/shared/atoms'
import { AssessmentNames } from '@/models/channels'

export default {
  components: {
    CAssessmentIcon,
    HSelect
  },
  props: {
    channelId: { type: String, default: undefined },
    assessment: { type: [String, undefined], default: undefined },
    disabled: Boolean
  },
  emits: ['changeAssessment'],
  data() {
    return {
      selectedAssessment: {}
    }
  },
  computed: {
    placeholder() {
      return this.disabled ? 'Canal não classificado' : 'Selecione na lista'
    },
    assessmentOptions() {
      return Object.entries(AssessmentNames).map(([key, value]) => ({
        key,
        value
      }))
    }
  },
  watch: {
    assessment: {
      immediate: true,
      handler() {
        if (this.assessment) {
          this.selectedAssessment = this.assessmentOptions.find(
            a => a.key === this.assessment
          )
        } else {
          this.selectedAssessment = {}
        }
      }
    }
  },
  methods: {
    onInput({ key: assessment }) {
      this.$emit('changeAssessment', assessment)
    }
  }
}
</script>
<style lang="scss" scoped>
.channel-assessment {
  &__option {
    display: flex;
  }
}
</style>
